import React from 'react';

const PageNotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white shadow-lg rounded-lg p-8 md:p-16 max-w-md">
        {/* Background Image */}
        <div
          className="mx-auto mb-6"
          style={{
            backgroundImage:
              'url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '300px',
            height: '300px',
          }}
        >
          <h1 className="text-5xl font-bold text-gray-800">404</h1>
        </div>

        {/* Content Box */}
        <div className="text-center">
          <h2 className="text-xl md:text-2xl font-semibold text-gray-700 mb-2">
            Looks like you're lost
          </h2>
          <p className="text-gray-600 mb-4">
            The page you are looking for is not available!
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;